// AHA https://codeburst.io/react-native-parallax-scroll-with-tabs-721feec463c5

import React, { Component } from 'react';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem } from 'native-base';
import { ListItem as Item, Tabs, Tab, ScrollableTab, TabHeading, Image, H2, H3, Grid, Col, H1 } from 'native-base';
import { Platform, Animated, View, StatusBar, Linking, PanResponder, TouchableOpacity, StyleSheet, WebView, Share, Dimensions } from 'react-native';
import Alert from '../../components/alert';
//import { Transition } from 'react-navigation-fluid-transitions';

import ActionButton from 'react-native-action-button';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

import PersonForm from '../PersonForm';
import RecentTransContainer from './recentTransList';
import StatementView from './statementView';
import DetailsTab from './detailsTab';
import PopupMenu from '../../components/popupMenu';

const { width: SCREEN_WIDTH } = Dimensions.get('window');
const IMAGE_HEIGHT = 250;
const HEADER_HEIGHT = Platform.OS === 'ios' ? 64 : 54;
const SCROLL_HEIGHT = IMAGE_HEIGHT - HEADER_HEIGHT;
const THEME_COLOR = 'rgba(67,142,185, 1.0)';
const FADED_THEME_COLOR = 'rgba(85,186,255, 0.8)';

//const AnimatedBody = Animated.createAnimatedComponent(Body);
//const AnimatedTabs = Animated.createAnimatedComponent(Tabs);
import styles from './styles';

const AnimatedActionButton = Animated.createAnimatedComponent(ActionButton);

class PersonDetails extends React.Component {
	nScroll = new Animated.Value(0);
	scroll = new Animated.Value(0);
	textColor = this.scroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT / 5, SCROLL_HEIGHT],
		outputRange: [THEME_COLOR, FADED_THEME_COLOR, 'white'],
		extrapolate: 'clamp'
	});
	tabBg = this.scroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT],
		outputRange: ['white', '#367396'],
		extrapolate: 'clamp'
	});
	tabHeadBg = this.scroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT],
		outputRange: ['#b4d0e0', '#1d628a'],
		extrapolate: 'clamp'
	});
	tabY = this.nScroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT, SCROLL_HEIGHT + 1],
		outputRange: [0, 0, 1]
	});
	headerBg = this.scroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT, SCROLL_HEIGHT + 1],
		outputRange: ['transparent', 'transparent', THEME_COLOR],
		extrapolate: 'clamp'
	});
	imgScale = this.nScroll.interpolate({
		inputRange: [-25, 0],
		outputRange: [1.1, 1],
		extrapolateRight: 'clamp'
	});
	imgOpacity = this.nScroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT],
		outputRange: [1, 0]
	});
	headScale = this.scroll.interpolate({
		inputRange: [0, SCROLL_HEIGHT],
		outputRange: [1.2, 1],
		extrapolate: 'clamp'
	});
	headMv = this.scroll.interpolate({
		//just move it to the left a little
		inputRange: [0, SCROLL_HEIGHT],
		outputRange: [20, 0],
		extrapolate: 'clamp'
	});
	state = {
		activeTab: 0,
		height: 500
	};
	constructor(props) {
		super(props);

		this.nScroll.addListener(Animated.event([{ value: this.scroll }], { useNativeDriver: false }));
	}

	call(url) {
		Linking.openURL(url).catch(err => console.log('An error occurred', err));
	}

	delete(id) {
		const { personType, details } = this.props;
		if (parseFloat(details.totalPayable)) return Alert.alert('Cannot delete', 'Customer has transactions');
		return Alert.alert(
			'Delete ' + personType,
			`Permanently delete this ${personType}?`,
			[
				{ text: 'Cancel', style: 'cancel' },
				{ text: 'OK', onPress: () => this.props.deletePerson(id) }
			],
			{ cancelable: true }
		);
	}

	editFinished(id) {
		//callback; id for new n/a here
		this.setState({ editing: false });
	}

	render() {
		const props = this.props;
		const { details, personType, navigation } = this.props;
		const isCustomer = this.props.personType == 'customer';
		if (!details) return <H3>Not found!</H3>;
		return (
			<View style={{ flex: 1 }}>
				{this.state.editing && <PersonForm closure={() => this.editFinished()} personType={personType} id={details.id} />}

				<Animated.View
					style={{
						position: 'absolute',
						width: '100%',
						backgroundColor: this.headerBg,
						zIndex: 1,
						transform: [{ scale: this.headScale }, { translateY: this.headMv }]
					}}>
					<Header style={{ backgroundColor: 'transparent' }} hasTabs>
						<Body style={{ flex: 1, justifyContent: 'center' }}>
							<Animated.Text style={{ color: isCustomer ? this.textColor : 'white', fontSize: 20, fontWeight: 'bold', textAlign: 'center', alignSelf: 'center' }}>{details.display}</Animated.Text>
						</Body>
					</Header>
				</Animated.View>
				<Button transparent style={{ position: 'absolute', left: 5, top: HEADER_HEIGHT - 48, zIndex: 1 }} onPress={() => navigation.goBack()}>
					<Icon active name="ios-arrow-back" style={{ color: '#FFF' }} />
				</Button>
				<Animated.ScrollView
					scrollEventThrottle={5}
					showsVerticalScrollIndicator={false}
					onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: this.nScroll } } }], { useNativeDriver: true })}
					style={{ zIndex: 0 }}>
					<Animated.View
						style={{
							transform: [{ translateY: Animated.multiply(this.nScroll, 0.65) }, { scale: this.imgScale }],
							backgroundColor: THEME_COLOR
						}}>
						<Animated.Image
							source={personType == 'customer' ? require('../../../assets/customer.png') : require('../../../assets/supplier.png')}
							style={{ height: IMAGE_HEIGHT, width: '100%', opacity: this.imgOpacity }}>
							{/*gradient
							<LinearGradient
								colors={["rgba(255,255,255,0.9)", "rgba(255,255,255,0.35)", "rgba(255,255,255,0)"]}
								locations={[0, 0.25, 1]}
								style={{ position: "absolute", height: "100%", width: "100%" }} />*/}
						</Animated.Image>
						<Animated.View style={{ position: 'absolute', flex: 1, top: HEADER_HEIGHT + 24, height: IMAGE_HEIGHT, width: '100%', opacity: this.imgOpacity, alignItems: 'center' }}>
							<Animated.Text style={[styles.customerName, { opacity: this.imgOpacity }]}>{details.name ? details.name : details.businessName}</Animated.Text>
							<Text style={styles.customerNumber}>{details.tel}</Text>
							<Text style={styles.customerNumber}>
								{details.address1} {details.address2} {details.postCode}
							</Text>

							<View style={styles.contactButtonsContainer}>
								{!!details.tel && (
									<TouchableOpacity onPress={() => this.call('tel:' + details.tel)} style={styles.contactButton}>
										<Icon name="md-call" style={{ color: 'green' }} />
									</TouchableOpacity>
								)}

								{!!details.tel && (
									<TouchableOpacity style={styles.contactButton} onPress={() => this.call('sms:' + details.tel)}>
										<Icon name="md-text" style={{ color: '#207cb9' }} />
									</TouchableOpacity>
								)}

								{!!details.email && (
									<TouchableOpacity style={styles.contactButton} onPress={() => this.call('mailto:' + details.email)}>
										<Icon name="md-mail" style={{ color: '#F8F5A7' }} />
									</TouchableOpacity>
								)}
								<TouchableOpacity style={styles.contactButton} onPress={() => this.setState({ editing: true })}>
									<FontAwesome name={'pencil'} style={{ color: 'white', fontSize: 24 }} />
								</TouchableOpacity>
								<View style={styles.contactButton}>
									<PopupMenu
										actions={[parseFloat(details.totalPayable) > 0 ? 'Cannot delete' : 'Delete']}
										style={{ color: '#DDD', paddingVertical: 3, paddingHorizontal: 5, flex: 1 }}
										onPress={(e, i) => {
											i === 0 && this.delete(details.id);
										}}
										destructiveButtonIndex={0}
									/>
								</View>
							</View>
						</Animated.View>
					</Animated.View>
					<Tabs
						//prerenderingSiblingsNumber={1}
						initialPage={0}
						/*
						renderTabBar={tabProps => (
							<Animated.View style={{ transform: [{ translateY: this.tabY }], zIndex: 1, width: '100%' }}>
								<ScrollableTab
									{...tabProps}
									style={{ backgroundColor: '#FFF' }}
									renderTab={(name, page, active, onPress, onLayout) => (
										<TouchableOpacity key={page} onPress={() => onPress(page)} onLayout={onLayout} activeOpacity={0.4}>
											<Animated.View
												style={{
													flex: 1,
													height: 100,
													backgroundColor: this.tabBg
												}}>
												<TabHeading
													scrollable
													style={{
														backgroundColor: 'transparent',
														width: isCustomer ? SCREEN_WIDTH / 2.5 : SCREEN_WIDTH / 2
													}}
													active={active}>
													<Animated.Text
														style={{
															fontWeight: active ? 'bold' : 'normal',
															color: this.textColor,
															fontSize: 14,
															padding: 10
														}}>
														{name}
													</Animated.Text>
												</TabHeading>
											</Animated.View>
										</TouchableOpacity>
									)}
									underlineStyle={{ width: isCustomer ? SCREEN_WIDTH / 2.5 : SCREEN_WIDTH / 2 }}
								/>
							</Animated.View>
						)}*/
					>
						<Tab heading="Recent">
							<View style={{ flexDirection: 'row', margin: 15 }}>
								<H3 style={{ textAlign: 'right', flex: 2.3 }}>Total transactions: </H3>
								<H3 style={{ flex: 1 }}>£{props.details.totalPayable}</H3>
							</View>
							<View style={{ flexDirection: 'row', marginBottom: 5 }}>
								<H2 style={{ textAlign: 'right', flex: 2.3 }}>Outstanding: </H2>
								<H2 style={{ flex: 1 }}>£{props.details.owes ? props.details.owes : props.details.owed}</H2>
							</View>
							<RecentTransContainer
								style={{ flex: null }}
								personId={this.props.details.id}
								personType={this.props.personType}
								navigation={this.props.navigation}
								onLayout={({
									nativeEvent: {
										layout: { height }
									}
								}) => {
									this.heights[1] = height;
									if (this.state.activeTab === 1) this.setState({ height });
								}}
							/>
						</Tab>

						{isCustomer && (
							<Tab heading="Statement">
								<StatementView webHeaders={props.headers} jwt={props.jwt} customer={details} />
							</Tab>
						)}
						<Tab heading="Details" style={{ flex: 0 }}>
							<DetailsTab details={details} />
						</Tab>
					</Tabs>
				</Animated.ScrollView>

				{isCustomer ? (
					<AnimatedActionButton buttonColor="#438eb9" hideShadow style={{ opacity: 0.85 }}>
						<ActionButton.Item buttonColor="#9b59b6" title="Invoice" onPress={() => props.navigation.navigate('Invoice', { customer_id: props.details.id })}>
							<Icon name="list-box" style={styles.actionButtonIcon} />
						</ActionButton.Item>
						<ActionButton.Item buttonColor="#3498db" title="Credit Note" onPress={() => props.navigation.navigate('Invoice', { customer_id: props.details.id, type: 'credit' })}>
							<Icon name="undo" style={styles.actionButtonIcon} />
						</ActionButton.Item>
						<ActionButton.Item buttonColor="#1abc9c" title="Take Payment" onPress={() => props.navigation.navigate('Entry', { addTrans: 'receipt', customer_id: props.details.id, paymentOnly: true })}>
							<Icon name="log-in" style={styles.actionButtonIcon} />
						</ActionButton.Item>
					</AnimatedActionButton>
				) : (
					<AnimatedActionButton buttonColor="#438eb9" hideShadow style={{ opacity: 0.85 }}>
						<ActionButton.Item buttonColor="#1abc9c" title="Make Payment" onPress={() => props.navigation.navigate('Entry', { addTrans: 'expense', supplier_id: props.details.id, paymentOnly: true })}>
							<Icon name="log-out" style={styles.actionButtonIcon} />
						</ActionButton.Item>
					</AnimatedActionButton>
				)}
			</View>
		);
	}
}

export default PersonDetails;
